module.exports = __webpack_public_path__ + "AnshulSoni-ca09d6eb.webp";